import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export const PickCursor = () => {
  const [visible, setVisible] = useState(false);
  const [hot, setHot] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 2000, damping: 90 });
  const sy = useSpring(y, { stiffness: 2000, damping: 90 });
  const vx = useMotionValue(0);
  const rotate = useTransform(vx, [-40, 0, 40], [-28, 0, 28]);
  const sRotate = useSpring(rotate, { stiffness: 300, damping: 25 });

  useEffect(() => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    let lastX = 0;
    const move = (e) => {
      vx.set(Math.max(-40, Math.min(40, e.clientX - lastX)));
      lastX = e.clientX;
      x.set(e.clientX);
      y.set(e.clientY);
      setVisible(true);
    };
    window.addEventListener("mousemove", move);
    const over = (e) => {
      const el = e.target instanceof Element ? e.target : null;
      setHot(!!el?.closest("a,button,[role='button'],input,select,textarea,label"));
    };
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y, vx]);

  if (typeof window !== "undefined" && !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return null;

  return (
    <motion.div
      aria-hidden
      className="fixed top-0 left-0 z-[100] pointer-events-none"
      style={{ x: sx, y: sy, rotate: sRotate, opacity: visible ? 1 : 0, translateX: "-50%", translateY: "-96%" }}
    >
      <motion.svg animate={{ scale: hot ? 1.35 : 1 }} transition={{ duration: 0.2 }} width="22" height="26" viewBox="0 0 22 26" fill="none" style={{ transformOrigin: "50% 100%" }}>
        <path
          d="M11 25C6 20 1 13.5 1 8C1 3.5 5.5 1 11 1C16.5 1 21 3.5 21 8C21 13.5 16 20 11 25Z"
          fill={hot ? "#210101" : "#DB0909"}
          fillOpacity="0.95"
          stroke="#0a0a0a"
          strokeWidth="1"
          style={{ transition: "fill 0.2s" }}
        />
      </motion.svg>
    </motion.div>
  );
};
